import styled from 'styled-components';
import PickupSvg from '../../assets/amenities/pickup.svg';

const PickupIcon = styled(PickupSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default PickupIcon;
